import { useId } from 'react'
import * as styled from '../../../util/styled'
import { Podcast, LayoutGrid, Newspaper, Globe, Users, MessageSquareQuote, UserPen } from 'lucide-react'
import { makeEnumSearchParamHook } from '../../../hooks/useSearchParam'

const Container = styled.div('overflow-x-auto mt-3')
const ItemWrapper = styled.label<{ active: boolean }>(props => [`
  group inline-flex items-center justify-between
  rounded-xl border-2
  py-3 px-5 cursor-pointer gap-2 mr-2 mb-2
`, {
  'border-border-standby hover:border-brand': !props.active,
  'border-brand': props.active,
}])
const makeIcon = (icon: typeof Podcast) => styled.component(icon)('w-5 h-5 text-brand')
const ItemRadio = styled.input('absolute opacity-0 h-0 w-0')


const options = [
  { key: 'all', title: 'All', icon: makeIcon(LayoutGrid) },
  { key: 'web', title: 'Blogs & News', icon: makeIcon(Newspaper) },
  { key: 'recent-news', title: 'Recent News', icon: makeIcon(Globe) },
  { key: 'journalists', title: 'Journalists', icon: makeIcon(Users) },
  { key: 'podcasts', title: 'Podcasts', icon: makeIcon(Podcast) },
  { key: 'guest-posts', title: 'Guest Posts', icon: makeIcon(UserPen) },
  { key: 'pitch-requests', title: 'Pitch Requests', icon: makeIcon(MessageSquareQuote) },
] as const
const keys = options.map(option => option.key)

export const useSearchType = makeEnumSearchParamHook('search_type', keys)

export type SearchTypeOption = (typeof options)[number]['key']
type SearchTypesOptionBarProps = {
  selected: SearchTypeOption
  onSelect: (option: SearchTypeOption) => void
}

export const SearchTypesOptionBar = (props: SearchTypesOptionBarProps) => {
  const {
    selected,
    onSelect,
  } = props
  const uid = useId()
  return (
    <Container>
      {options.map(option => {
        const IconComponent = option.icon
        return (
          (
            <ItemWrapper key={option.key} active={selected === option.key}>
              <ItemRadio
                id={`${uid}-${option.key}`}
                name={uid}
                type="radio"
                checked={selected === option.key}
                onChange={() => onSelect(option.key)}
              />
              <IconComponent />
              {option.title}
            </ItemWrapper>
          )
        )
      })}
    </Container>
  )
}